import { all, call, put, takeLatest } from 'redux-saga/effects';
import ApiService from 'services/ApiService';
import LocalStorage from 'services/LocalStorage';
import { UserActions, UserActionTypes } from './actions';

function* loadUser() {
  // yield put(UserActions.loadCurrentUserRequest());
  // try {
  //   const response = yield call(ApiService.getCurrentUser);
  //   yield put(UserActions.loadCurrentUserSuccess(response.data));
  // } catch (e) {
  //   yield put(UserActions.loadCurrentUserFailure(e));
  // }
}

// function* onUserSet(action) {
//   const user = action.payload;

//   yield call(LocalStorage.set, LocalStorage.KEYS.USER, user);
// }

export default function* watch() {
  yield all([
    // takeLatest(UserActionTypes.CURRENT_USER.LOAD, loadUser),
    // takeLatest(UserActionTypes.CURRENT_USER.COMPLETED, onUserSet),
  ]);
}
